import React, { FC, useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Spinner } from 'components/Spinner/Spinner'
import { toRelativeUrl } from '@okta/okta-auth-js'

export const AuthenticationProvider: FC = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth()

  useEffect(() => {
    if (!authState) return
    if (!authState.isAuthenticated) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin)
      oktaAuth.setOriginalUri(originalUri)
      oktaAuth.signInWithRedirect()
    }
  }, [authState, oktaAuth])

  return authState?.isAuthenticated ? <>{children}</> : <Spinner />
}
